import { YouTubePlayer } from '@angular/youtube-player';
import { NgModule } from '@angular/core';

import { YoutubePlayerComponent } from '@shared/modules/youtube-player/youtube-player.component';

@NgModule({
  declarations: [YoutubePlayerComponent],
  exports: [YoutubePlayerComponent],
  imports: [YouTubePlayer],
})
export class YoutubePlayerModule {}
